/**
 * Enumeration of page names (app page in CMS converted to lower case)
 */
export enum ApplicationPages {
	PriceCorrection = 'pricecorrection',
	GasStationCorrection = 'gasstationcorrection',
	Success = 'confirmation'
}